type Listener = (state: { count: number; progress: number | null }) => void;

const listeners = new Set<Listener>();
let count = 0;
let progress: number | null = null;

export const loadingEmitter = {
  show(percent?: number) {
    count++;
    if (percent !== undefined) {
      progress = percent;
    }
    listeners.forEach((fn) => fn({ count, progress }));
  },
  hide() {
    count = Math.max(0, count - 1);
    if (count === 0) {
      progress = null;
    }
    listeners.forEach((fn) => fn({ count, progress }));
  },
  updateProgress(percent: number) {
    progress = percent;
    listeners.forEach((fn) => fn({ count, progress }));
  },
  subscribe(fn: Listener) {
    listeners.add(fn);
    fn({ count, progress });
    return () => { listeners.delete(fn); };
  },
};